<template>
  <div class="notifyVue">
    <div class="o-main-content-area">
        <div class="row c-responsive-fixwidth">
            <div class="col-md-12">
                <h1 class="h1">Notify</h1>
                <div class="o-subtitleHeading">
                    <label class="o-blue-regular-text">Send to:</label>
                    <div v-show="getPower('notifyAllEmployee')" class="radio o-custom-radio">
                        <label>
                            All Employee
                            <input type="radio" name="o3" value="employee" v-model="type" @change="changeType()">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    </div>
                    <div v-show="getPower('notifyAllStatus')" class="radio o-custom-radio">
                        <label>
                            By Status
                            <input type="radio" name="o3" value="status" v-model="type" @change="changeType()">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    </div>
                    <div v-show="getPower('notifyAllSkill')" class="radio o-custom-radio">
                        <label>
                            By Skill
                            <input type="radio" name="o3" value="skill" v-model="type" @change="changeType()" :checked="selectType == 'all'">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    </div>
                    <div v-show="getPower('notifyMyJob')" class="radio o-custom-radio">
                        <label>
                            By Job
                            <input type="radio" name="o3" value="job" v-model="type" @change="changeType()" :checked="selectType == 'none'">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    </div>
                    <div class="radio o-custom-radio" v-if="userRoleSlug=='client-admin'&&mailing_list_visibility_flag">
                        <label>
                            Other IATSE CS Locals
                            <input type="radio" name="o3" value="other_iatse_locals" v-model="type" @change="changeType()" :checked="selectType == 'none'">
                            <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="o-notifications c-responsive-fixwidth">
            <div class="row">
                <div class="col-sm-12">
                    <div v-if="type != 'other_iatse_locals'" class="o-notifications-checkbox c-common-box-shadow c-radius3 c-margin-bottom-10">
                        <div class="notifications-checkbox-head notify-custome-head">
                            <div class="o-subtitleHeading notify-custome notify-custome-radio">
                                <label class="o-blue-regular-text">Select:</label>
                                <div class="radio o-custom-radio">
                                    <label>
                                        All
                                        <input type="radio" name="o4" value="all" v-model="selectType" @change="selectAllData()" >
                                        <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                    </label>
                                </div>
                                <div class="radio o-custom-radio">
                                    <label>
                                        None
                                        <input type="radio" name="o4" value="none" v-model="selectType" @change="selectNone()">
                                        <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                    </label>
                                </div>
                                <div class="radio o-custom-radio ml-45" v-show="type=='skill'">
                                    <label>
                                        Status:                                     
                                        <el-select 
                                        v-model="selectedEmployeeStatuses" 
                                        :collapse-tags="true" 
                                        multiple 
                                        placeholder="Select Status" 
                                        @change="onSkillStatusesSelected" 
                                        style="width:300px;">
                                            <el-option
                                            v-for="item in statusListData"
                                            :key="item.id"
                                            :label="item.name"                                            
                                            :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </label>
                                </div>
                            </div>
                            <div v-show="getPower('notifyMyJobFilter')" v-if="type == 'job'" class="notify-custome notify-custome-padding">
                                <div class="custom-date-range-field">
                                    <label for="exampleInputEmail3" class="common-label-text">Select :</label>
                                    <div class="o-cutsomSelect o-display-inline">
                                        <select v-model="prevdatelenth" @change="getJob()" class="form-control fix-width-input">
                                            <option value="30">Last 30 days</option>
                                            <option value="90">Last 90 days</option>
                                            <option value="1">Today and Future</option>
                                            <option value="0">Custom Date Range</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if ="prevdatelenth==0" class="custom-date-range-field">
                                    <ul class="custom-date-range-select">
                                        <li>
                                            <div class="">
                                                <label for="" class="common-label-text lebel-width">Start Date:</label>
                                                <div class="o-display-inline lebel-width-field">
                                                    <el-date-picker
                                                        type="date"
                                                        :placeholder="getDatePlaceholder()"
                                                        style="width: 100%;"
                                                        v-model="customDateRange.start"
                                                        :format="getDisplayFormat()"
                                                        value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="">
                                                <label for="" class="common-label-text lebel-width">End Date:</label>
                                                <div class="o-display-inline lebel-width-field">
                                                    <el-date-picker
                                                        type="date"
                                                        :placeholder="getDatePlaceholder()"
                                                        style="width: 100%;"
                                                        v-model="customDateRange.end"
                                                        :format="getDisplayFormat()"
                                                        value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if ="prevdatelenth==0" class="custom-date-range-field">
                                    <button @click="getJob()" class="btn notify-go-btn">GO</button>
                                </div>
                            </div>
                        </div>
                        <div class="notifications-checkbox-body1" v-loading.this.lock="lockList">
                           <div class="notification-scroll" v-if="list.length">
                                <div class="row" >
                                    <div class="col-md-3"> 
                                        <ul v-if="subList1.length">
                                            <li v-for="(data,index) in subList1" :key="index">
                                                <div class="checkbox o-custom-radio" >
                                                    <label v-if="data">
                                                        {{(type == 'employee') ? getLastName(data)+getFirstName(data) : ((type == 'job')?data.title:data.name)}}
                                                        <input type="checkbox" name="o4" :value="data.id" v-model="selectedData">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-3"> 
                                        <ul v-if="subList2.length">
                                            <li v-for="(data,index) in subList2" :key="index">
                                                <div class="checkbox o-custom-radio" >
                                                    <label v-if="data">
                                                        {{(type == 'employee')?getLastName(data)+getFirstName(data):((type == 'job')?data.title:data.name)}}
                                                        <input type="checkbox" name="o4" :value="data.id" v-model="selectedData">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-3"> 
                                        <ul v-if="subList3.length">
                                            <li v-for="(data,index) in subList3" :key="index">
                                                <div class="checkbox o-custom-radio" >
                                                    <label v-if="data"> 
                                                        {{(type == 'employee')?getLastName(data)+getFirstName(data):((type == 'job')?data.title:data.name)}}
                                                        <input type="checkbox" name="o4" :value="data.id" v-model="selectedData">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-3">
                                        <ul v-if="subList4.length">
                                            <li v-for="(data,index) in subList4" :key="index">
                                                <div class="checkbox o-custom-radio" >
                                                    <label v-if="data">
                                                        {{(type == 'employee')?getLastName(data)+getFirstName(data):((type == 'job')?data.title:data.name)}}
                                                        <input type="checkbox" name="o4" :value="data.id" v-model="selectedData">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="type != 'other_iatse_locals'">
                <div class="custom-date-range-field ml-15 mb-10" style="display: flex; align-items: center;">
                    <label for="exampleInputEmail3" class="common-label-text">Send Via:</label>
                    <div class="o-cutsomSelect o-display-inline">
                        <select v-model="notifyChannel" @change="changeNotify()" class="form-control fix-width-input">
                            <option value="app">App</option>
                            <option value="email">Email</option>
                            <option value="sms">SMS</option>
                        </select>
                    </div>
                    <a v-if="notifyChannel=='app'" href="javascript: void(0)"
                        @click="sendNotify()"
                        :disabled="disableSendSMS"
                        :class="{ 'isDisabled': disableSendSMS }" class="c-solid-btn c-solid-btn--green" style="margin-left: 10px;">
                        <i class="fa fa-paper-plane" aria-hidden="true"></i> Send Notify
                    </a>
                    <a v-if="notifyChannel=='email' || type=='other_iatse_locals'" href="javascript: void(0)" @click="sendEmail()" class="c-solid-btn c-solid-btn--green" :disabled="disableSendEmail" style="margin-left: 10px;">
                        <i class="fa fa-paper-plane" aria-hidden="true"></i>
                        Send Email
                    </a>
                    <a v-if="notifyChannel=='sms'" href="javascript: void(0)" @click="sendSMS()" :disabled="disableSendSMS" :class="{ 'isDisabled': disableSendSMS }" class="c-solid-btn c-solid-btn--green" style="margin-left: 10px;">
                        <i class="fa fa-paper-plane" aria-hidden="true"></i>
                        Send SMS
                    </a>
                </div>
            </div>
            <div class="row">
                <div v-if="!isCallstewardUK()&&(notifyChannel=='app')" class="col-sm-5">
                    <div class="o-notifications-sms">
                        <h2 class="h2">APP Notify Message</h2>
                        <div class="o-sms-counter">{{appNotifyMessage.length}}/240</div>
                        <div v-loading.this.lock="smsLoading" class="form-group n-sms-margin">
                            <textarea 
                                :maxlength="240"
                                class="form-control c-common-box-shadow c-radius3" 
                                :class="{ 'error-border': error.app && error.app.hasError }"
                                v-model="appNotifyMessage"
                                rows="9"
                                placeholder="Type your message"
                                @input="validateContent('app', appNotifyMessage)"
                            ></textarea>
                            <span v-if="error.app && error.app.hasError" class="err-msg">
                                {{ error.app.message }}
                            </span>
                        </div>
                        <div class="form-group o-attachment-sec common-margin-bottom20">
                            <!-- #1538: app-push attachment — mirrors the Email block; backend #1506 reads file('attachment') -->
                            <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button>
                                <input type="file" name="myfile" @input="attachmentAdded($event)">
                                <span>{{(attachment)?attachment.name:'No file chosen'}}</span>
                                <span style="color: red; margin-left: 8px;">max 30MB</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-7" v-if="notifyChannel=='email' || type=='other_iatse_locals'">
                    <div class="o-notifications-email" v-loading.this.lock="emailLoading">
                        <h2 class="h2">Email message</h2>
                        <div class="form-group">
                            <input v-model="emailSubject" class="form-control c-common-box-shadow c-radius3" type="text" placeholder="Subject">
                        </div>
                        <div class="form-group o-attachment-sec common-margin-bottom20">  
                            <vue-editor 
                                id="editor1" 
                                class="c-common-box-shadow c-radius3" 
                                :class="{ 'error-border': hasError }"
                                v-model="email"                                
                                @text-change="validateContent('email', email)"
                            ></vue-editor>
                            <span 
                                v-if="error.email && error.email.hasError" 
                                class="err-msg"
                            > 
                                {{ error.email.message }}
                            </span>

                            <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button>
                                <input type="file" name="myfile" @input="attachmentAdded($event)">
                                <span>{{(attachment)?attachment.name:'No file chosen'}}</span>
                                <span style="color: red; margin-left: 8px;">max 30MB</span>
                            </div>

                        </div>

                    </div>
                </div>
                <div v-else-if="!isCallstewardUK()&&(notifyChannel=='sms')" class="col-sm-5">
                    <div class="o-notifications-sms">
                        <h2 class="h2">SMS message</h2>
                        <div class="o-sms-counter">{{sms.length}}/160</div>
                        <div v-loading.this.lock="smsLoading" class="form-group n-sms-margin">
                            <textarea 
                                :maxlength="160"
                                class="form-control c-common-box-shadow c-radius3" 
                                :class="{ 'error-border': error.sms && error.sms.hasError }"
                                v-model="sms"
                                rows="9"
                                placeholder="Type your SMS"
                                @input="validateContent('sms', sms)"
                            ></textarea>
                            <span v-if="error.sms && error.sms.hasError" class="err-msg">
                                {{ error.sms.message }}
                            </span>
                        </div>
                        
                    </div>
                </div>
            </div>

        </div>
    </div>
  </div>
</template>

<script>
    import { VueEditor } from 'vue2-editor';
import { sortByStatusPriority } from '../statusPriorityOrder.js';
import { findContentProblems, describeContentProblems, stripHtml } from '../contentRules.js';
    import service from '../services.js';
    import { buildNotifyMessage } from '../utils/notifyStats.js';
    import dateTimeConvert from '../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                disableSendEmail: false,
                disableSendSMS: false,
                emailSubject:'',
                type: 'employee',
                list: [],
                selectedData: [],
                attachment : null,
                all: 1,
                none: 0,
                lockList: true,
                emailLoading:false,
                smsLoading:false,
                selectType: 'none',
                email: "",
                sms: "",
                notifyCustom: {
                    startDate: '',
                    endDate: ''

                },
                prevdatelenth: '30',
                customDateRange: {
                    start: '',
                    end: '',
                },
                subList1: [],
                subList2: [],
                subList3: [],
                subList4: [],
                displayEmployeesSection: false,
                clientData: null,
                mailing_list_visibility_flag:false,
                statusListData: [],
                selectedEmployeeStatuses: [],
                notifyChannel: 'email',
                appNotifyMessage: '',
                hasError: false,
                error: {},
            };
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                userRoleSlug: 'userRoleSlug',
                userID: 'userID'
            })
        },
        methods: {
            getLastName(data) {
                let name = '';
                if(data&&data.last_name){ name = data.last_name+", "; }
                return name;
            },
            getFirstName(data) {
                let name = '';
                if(data&&data.first_name){ name = data.first_name; }
                return name;
            },
            onSkillStatusesSelected(statuses) {                
                this.selectedEmployeeStatuses = [...statuses];
                console.log(this.selectedEmployeeStatuses);
            },
            async getClientData() {
                await service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.clientData = res.data.result;
                    this.mailing_list_visibility_flag = this.clientData.mailing_list_visibility_flag
                }).catch((err) => {
                    console.log(err);
                });
            },
            isCallstewardUK(){
                return dateTimeConvert.isCallstewardUK();
            },
            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            checkSteward(){
                // console.log('checkSteward');
                service.get('employee/'+this.employeeId +'/checkSkill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'user-id':this.userID
                })
                .then((res) => {
                    // this.isSteward=res.data.result;
                    // console.log(res);
                    if(res.data.result !=1 && this.userRoleSlug=='employee') {
                        this.$router.push({
                            path: `/`
                        });
                    }
                }).catch((err) => {
                    this.$Progress.fail();
                });
            },
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            attachmentAdded($event) {
                if($event.target.files.length != 0) {
                    const file = $event.target.files[0];
                    // #1538: enforce the 30MB cap client-side (shared by App + Email channels).
                    const MAX_BYTES = 30 * 1024 * 1024;
                    if (file.size > MAX_BYTES) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Attachment exceeds the 30MB limit. Please choose a smaller file.'
                        });
                        $event.target.value = '';
                        this.attachment = null;
                        return;
                    }
                    this.attachment = file;
                } else {
                    this.attachment = null;
                }
              //console.log(this.attachment.name);
            },
            async changeType() {
                this.list = [];
                this.subList1 = [];
                this.subList2 = [];
                this.subList3 = [];
                this.subList4 = [];
                //console.log('go to job');
                this.lockList = true;
                if (this.type == 'employee'){
                    this.getEmployees();
                }
                if (this.type == 'status') {
                    this.getStatus();
                }
                if (this.type=='skill'){
                    await this.getStatus();
                    await this.getSkill();
                }
                if (this.type == 'job') {
                    this.getJob();
                }
                if (this.type == 'other_iatse_locals'){
                    this.displayEmployeesSection=false;
                }
            },
            async getEmployees() {
                //this.lockList = true;
                this.selectedData = [];
                this.list = [];
                this.subList1 = [];
                this.subList2 = [];
                this.subList3 = [];
                this.subList4 = [];
                await service.get('employee/clientEmployees', {
                    'Authorization': this.userToken,
                    'clientId': this.userClientID,
                    'user-id':this.userID
                }).
                then(async (res) => {
                    this.list = res.data.result;
                    if (this.selectType == 'all')
                        this.selectAllData();
                    else
                        this.selectNone();
                    this.lockList = false;
                    await this.divideListToSubLists(this.list);

                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
            },
            async getStatus() {
                console.log("Status");
                this.lockList = true;
                this.selectedData = [];
                this.list = [];
                this.subList1 = [];
                this.subList2 = [];
                this.subList3 = [];
                this.subList4 = [];
                this.statusListData = [];
                await service.get('employee/employee_status', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID,
                    'user-id':this.userID
                }).
                then(async (res) => {
                    // #1964 — ed, 2026-09-30 17:20: he sends by STATUS [PRIORITY], so
                    // BOTH status lists on this page are ordered the same way, by
                    // `employee_statuses.priority` compared as a DECIMAL.
                    //
                    // They used to differ: By Status re-sorted here while the By Skill
                    // filter took the API order as it came. The server now orders both
                    // endpoints (StatusPriorityOrder), and both lists apply the same
                    // comparator again here so the two dropdowns cannot drift apart —
                    // which is the symptom #1964 was filed about.
                    //
                    // ⚠ `employee_statuses.priority`, NOT `employees.seniority`. They
                    // are different fields (ed, 17:22).
                    if(this.type == 'skill') {
                        this.statusListData = sortByStatusPriority(res.data.result);
                    } else { 
                        this.list = sortByStatusPriority(res.data.result);                
                        if (this.selectType == 'all')
                            this.selectAllData();
                        else
                            this.selectNone();
                        this.lockList = false;
                        await this.divideListToSubLists(this.list);
                    }

                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });

            },
            async divideListToSubLists(list){
                this.subList1 = [];
                this.subList2 = [];
                this.subList3 = [];
                this.subList4 = [];
                let listLength = list.length;
                let subListItemCount1 = parseInt((listLength + 4) / 4);
                let subListItemCount2 = 2 * subListItemCount1;
                let subListItemCount3 = 3 * subListItemCount1;
                for(let index=0;index<listLength;index++){
                    if(index<subListItemCount1)
                        this.subList1.push(list[index])
                    else if(index<subListItemCount2)
                        this.subList2.push(list[index])
                    else if(index<subListItemCount3)
                        this.subList3.push(list[index])
                    else
                        this.subList4.push(list[index])
                }

            },
            async getSkill() {
                console.log("Skill");
                this.lockList = true;
                this.selectedData = [];
                this.list = [];
                this.subList1 = [];
                this.subList2 = [];
                this.subList3 = [];
                this.subList4 = [];
                await service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID,
                    'user-id':this.userID
                }).
                then((res) => {
                    this.list = res.data.result;
                    if (this.selectType == 'all')
                        this.selectAllData();
                    else
                        this.selectNone();

                    this.lockList = false;
                    this.divideListToSubLists(this.list);
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });

            },
            async getJob() {
                this.selectedData = [];
                this.list = [];
                this.subList1 = [];
                this.subList2 = [];
                this.subList3 = [];
                this.subList4 = [];
                let headerdata = {};               
                if (this.prevdatelenth == '30') {
                    headerdata = {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'days': this.prevdatelenth,
                        'selectedDate': moment().format('YYYY-MM-DD HH:mm:ss'),
                        'user-id':this.userID,
                        'employee-id': this.employeeId
                    };
                } else if (this.prevdatelenth == '90') {
                    var day30th = moment().subtract(30, 'days').calendar();
                    headerdata = {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'days': this.prevdatelenth,
                        'selectedDate': moment(day30th).format('YYYY-MM-DD HH:mm:ss'),
                        'user-id':this.userID,
                        'employee-id': this.employeeId
                    };
                } else if (this.prevdatelenth == 1) {
                    headerdata = {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'type': 'today_future',
                        'user-id':this.userID,
                        'employee-id': this.employeeId
                    };
                } else {
                    headerdata = {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'start': moment(this.customDateRange.start).format('YYYY-MM-DD HH:mm:ss'),
                        'end': moment(this.customDateRange.end).format('YYYY-MM-DD HH:mm:ss'),
                        'user-id':this.userID,
                        'employee-id': this.employeeId
                    };
                }
                if(this.$cookies.get('csLogin')=='client-admin' || this.$cookies.get('csLogin')=='power-user') {
                    if ((this.prevdatelenth == 0 && this.customDateRange.start != '' && this.customDateRange.end != '') || (this.prevdatelenth != 0)) {
                        this.lockList = true;
                        await service.get('job/jobByGivenNoOfDays', headerdata).
                        then((res) => {
                            this.list = res.data.result;
                            if (this.selectType == 'all')
                                this.selectAllData();
                            else
                                this.selectNone();
                            this.lockList = false;
                            this.divideListToSubLists(this.list);
                        }).catch((err) => {
                            console.log(err);
                            this.lockList = false;
                        });
                    }
                } else {
                    if ((this.prevdatelenth == 0 && this.customDateRange.start != '' && this.customDateRange.end != '') || (this.prevdatelenth != 0)) {
                        this.lockList = true;
                        await service.get('job/myJob', headerdata).
                        then((res) => {
                            this.list = res.data.result.data;
                            if (this.selectType == 'all')
                                this.selectAllData();
                            else
                                this.selectNone();
                            this.lockList = false;
                            this.divideListToSubLists(this.list);
                        }).catch((err) => {
                            console.log(err.response);
                            this.lockList = false;
                        });
                    }
                }
            },
            selectAllData() {
                this.all = 1;
                this.none = 0;
                this.addToList();
            },
            addToList() {
                let instance = this;
                this.list.forEach(function(data) {
                    instance.selectedData.push(data.id);
                });
            },
            selectNone() {
                this.all = 0;
                this.none = 1;
                this.selectedData = [];
            },
            async sendMailOtherIatseLocals() {
                this.emailLoading=false;
                if (this.email != "" && this.emailSubject!=""){
                    let params = new FormData();
                    params.append("email", this.email);
                    params.append("subject", this.emailSubject);
                    params.append("client_id", this.userClientID);
                    params.append("user_id", this.userID);
                    if(this.attachment != null)
                    {
                        params.append("attachment", this.attachment);
                    }

                    await service.post('employee/notifyEmployeeByMailingList', params, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.emailLoading=false;
                        this.$notify({
                            title: this.$t('success'),
                            message: buildNotifyMessage(res),
                            type: 'success'
                        });
                        this.email = "";
                        this.emailSubject = "";
                        this.disableSendEmail = false;
                    }).catch((err) => {
                        console.log(err);
                        var errMsg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Email failed to send';
                        this.$notify.error({ title: this.$t('error'), message: errMsg });
                        this.emailLoading=false;
                        this.disableSendEmail = false;
                    });
                }else {
                    if(this.email == "" || this.emailSubject =="") {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'You cannot send a blank email'
                        });
                    }
                }
            },
            async sendEmail() {
                this.error = {};
                this.validateContent('email', this.email);

                if (this.hasValidationErrors()) {
                    this.$notify.error({
                        title: 'Error', 
                        message:'Please fix validation errors before saving.'}
                    ); 
                    return; // Stop the save process
                }

                this.disableSendEmail = true;
                if(this.type == 'other_iatse_locals') {
                    await this.sendMailOtherIatseLocals();
                    return;
                }

                if (this.email != "" && this.emailSubject!="" && this.selectedData.length) {
                    var url;
                    var params;
                    if (this.type == 'employee') {
                        url = 'employee/notifyEmployee';
                        var params = new FormData();
                        params.append("email", this.email);
                        params.append("subject", this.emailSubject);
                        params.append("employee_ids",JSON.stringify(this.selectedData));
                        // this.selectedData.forEach(id => {
                        //     params.append('employee_ids[]', id);
                        // });
                        params.append("client_id", this.userClientID);
                        params.append("user_id", this.userID);
                        if(this.attachment != null)
                        {
                          params.append("attachment", this.attachment);
                        }
                    }
                    if (this.type == 'status') {
                        url = 'employee/notifyEmployeeByStatus';
                        var params = new FormData();
                        params.append("email", this.email);
                        params.append("subject", this.emailSubject);
                        params.append("employee_status",JSON.stringify(this.selectedData));
                        params.append("client_id", this.userClientID);
                        params.append("user_id", this.userID);
                        if(this.attachment != null)
                        {
                          params.append("attachment", this.attachment);
                        }
                    }
                    if (this.type == 'skill') {
                        url = 'employee/notifyEmployeeBySkill';
                        let selectedEmployeeStatuses = this.selectedEmployeeStatuses.length ? [...this.selectedEmployeeStatuses] : [];
                        var params = new FormData();
                        params.append("email", this.email);
                        params.append("subject", this.emailSubject);
                        params.append("skills",JSON.stringify(this.selectedData));
                        params.append("client_id", this.userClientID);
                        params.append("user_id", this.userID);
                        params.append("employee_statuses", JSON.stringify(selectedEmployeeStatuses));
                        if(selectedEmployeeStatuses.length) {
                            params.append("employee_statuses", JSON.stringify(selectedEmployeeStatuses));
                        }
                        if(this.attachment != null)
                        {
                          params.append("attachment", this.attachment);
                        }
                    }
                    if (this.type == 'job') {
                        url = 'employee/notifyEmployeeByJob';
                        var params = new FormData();
                        params.append("email", this.email);
                        params.append("subject", this.emailSubject);
                        params.append("jobs",JSON.stringify(this.selectedData));
                        params.append("client_id", this.userClientID);
                        if(this.attachment != null)
                        {
                          params.append("attachment", this.attachment);
                        }
                    }

                    this.emailLoading=true;
                    await service.post(url, params, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                        'user-id':this.userID
                    }).
                    then((res) => {
                        this.emailLoading=false;
                        this.$notify({
                            title: this.$t('success'),
                            message: buildNotifyMessage(res),
                            type: 'success'
                        });
                        this.email = "";
                        this.sms = "";
                        this.emailSubject = "";
                        this.attachment = null;
                        this.disableSendEmail = false;
                    }).catch((err) => {
                        console.log(err);
                        if(err.response&&err.response.data){
                            this.$notify({ title:'Error!', message:err.response.data.message, type:'error' });
                        }else {
                             this.$notify({ title:'Error!', message: 'Something went wrong!', type:'error' });
                        }
                        this.emailLoading=false;
                        this.disableSendEmail = false;
                    });
                } else {
                    if(this.email == "" && this.emailSubject =="") {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'You cannot send a blank email'
                        });
                    } else if(this.type=='employee' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one employee to send email'
                        });
                    }else if(this.type=='status' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one status to send email'
                        });
                    }else if(this.type=='skill' && !this.selectedData.length){
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one skill to send email'
                        });
                    }else if(this.type=='job' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one job to send email'
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Please fill in required fields'
                        });
                    }
                }
                this.disableSendEmail = false;
            },
            changeNotify() {
                this.appNotifyMessage = '';
            },
            async sendNotify() {
                if (this.appNotifyMessage != "" && this.selectedData.length) {
                    var url;
                    // #1538: FormData so the app-push attachment file can ride along
                    // (these endpoints already accept multipart from the Email path).
                    var params = new FormData();
                    this.error = {};
                    this.validateContent('app', this.appNotifyMessage);
                    if(this.hasValidationErrors()) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before sending notification.'}
                        ); 
                        return; // Stop the save process
                    }
                    if (this.type == 'employee') {
                        url = 'employee/notifyEmployee';
                        params.append('app', this.appNotifyMessage);
                        params.append('employee_ids', JSON.stringify(this.selectedData));
                        params.append('client_id', this.userClientID);
                    }
                    if (this.type == 'status') {
                        url = 'employee/notifyEmployeeByStatus';
                        params.append('app', this.appNotifyMessage);
                        params.append('employee_status', JSON.stringify(this.selectedData));
                        params.append('client_id', this.userClientID);
                        params.append('user_id', this.userID);
                    }
                    if (this.type == 'skill') {
                        let selectedEmployeeStatuses = this.selectedEmployeeStatuses.length ? [...this.selectedEmployeeStatuses] : [];
                        url = 'employee/notifyEmployeeBySkill';
                        params.append('app', this.appNotifyMessage);
                        params.append('skills', JSON.stringify(this.selectedData));
                        params.append('client_id', this.userClientID);
                        params.append('user_id', this.userID);
                        if(selectedEmployeeStatuses.length){
                            params.append('employee_statuses', JSON.stringify(selectedEmployeeStatuses));
                        }
                    }
                    if (this.type == 'job') {
                        url = 'employee/notifyEmployeeByJob';
                        params.append('app', this.appNotifyMessage);
                        params.append('jobs', JSON.stringify(this.selectedData));
                        params.append('client_id', this.userClientID);
                    }

                    // #1538: attach the chosen file if present (backend #1506 reads file('attachment')).
                    if (this.attachment != null) {
                        params.append('attachment', this.attachment);
                    }

                    this.smsLoading=true;
                    await service.post(url, params, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                        'user-id': this.userID
                    }).
                    then((res) => {
                        this.smsLoading=false;
                        this.$notify({
                            title: this.$t('success'),
                            message: buildNotifyMessage(res),
                            type: 'success'
                        });
                        this.appNotifyMessage = "";
                    }).catch((err) => {
                        console.log(err);
                        var errMsg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Push notification failed to send';
                        this.$notify.error({
                            title: this.$t('error'),
                            message: errMsg
                        });
                        this.smsLoading=false;
                    });
                }else {
                    if (!this.selectedData.length && this.appNotifyMessage == '') {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'You cannot send a blank push notification'
                        });
                    }else if(this.type=='employee' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one employee to notify'
                        });
                    }else if(this.type=='status' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one status to notify'
                        });
                    }else if(this.type=='skill' && !this.selectedData.length){
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one skill to notify'
                        });
                    }else if(this.type=='job' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one job to notify'
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Please fill in required fields'
                        });
                    }
                }
            },
            async sendSMS() {
                this.disableSendSMS = true;
                if (this.sms != "" && this.selectedData.length) {
                    var url;
                    var params;
                    this.validateContent('sms', this.sms);                    
                    if(this.hasValidationErrors()) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before sending notification.'}
                        );
                        this.disableSendSMS = false; 
                        return; // Stop the save process
                    }
                    if (this.type == 'employee') {
                        url = 'employee/notifyEmployee';
                        params = {
                            'sms': this.sms,
                            'employee_ids': JSON.stringify(this.selectedData),
                            'client_id': this.userClientID
                        };
                    }
                    if (this.type == 'status') {
                        url = 'employee/notifyEmployeeByStatus';
                        params = {
                            'sms': this.sms,
                            'employee_status': JSON.stringify(this.selectedData),
                            'client_id': this.userClientID,
                            'user_id': this.userID
                        };
                    }
                    if (this.type == 'skill') {
                        let selectedEmployeeStatuses = this.selectedEmployeeStatuses.length ? [...this.selectedEmployeeStatuses] : [];
                        url = 'employee/notifyEmployeeBySkill';
                        params = {
                            'sms': this.sms,
                            'skills': JSON.stringify(this.selectedData),
                            'client_id': this.userClientID,
                            'user_id': this.userID,
                        };
                        if(selectedEmployeeStatuses.length){
                            params.employee_statuses = JSON.stringify(selectedEmployeeStatuses);
                        }
                    }
                    if (this.type == 'job') {
                        url = 'employee/notifyEmployeeByJob';
                        params = {
                            'sms': this.sms,
                            'jobs': JSON.stringify(this.selectedData),
                            'client_id': this.userClientID
                        };
                    }

                    this.smsLoading=true;
                    await service.post(url, params, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                        'user-id': this.userID
                    }).
                    then((res) => {
                        this.smsLoading=false;
                        this.$notify({
                            title: this.$t('success'),
                            message: buildNotifyMessage(res),
                            type: 'success'
                        });
                        this.sms = "";
                        this.email = "";
                    }).catch((err) => {
                        console.log(err);
                        var errMsg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'SMS failed to send';
                        this.$notify.error({
                            title: this.$t('error'),
                            message: errMsg
                        });
                        this.smsLoading=false;
                        this.emailSubject = "";
                    });
                } else {
                    if (!this.selectedData.length && this.sms == '') {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'You cannot send a blank SMS'
                        });
                    }else if(this.type=='employee' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one employee to send SMS'
                        });
                    }else if(this.type=='status' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one status to send SMS'
                        });
                    }else if(this.type=='skill' && !this.selectedData.length){
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one skill to send SMS'
                        });
                    }else if(this.type=='job' && !this.selectedData.length) {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Select at least one job to send SMS'
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Please fill in required fields'
                        });
                    }
                }
                this.disableSendSMS = false;
            },

            validateContent(fieldName, value) {
                // Initialize error object if it doesn't exist
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                // Reset error state for this field
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                // Get plain text content (strip HTML tags)
                const plainText = this.getPlainText(value);
                
                // Only validate if there's content
                if (plainText.trim().length > 0) {
                    // #1952 — ed, 2026-09-30: "a, show it". Name every offender and where it
                    // is; never rewrite what the user pasted.
                    const problems = findContentProblems(plainText);
                    if (problems.length > 0) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            problems: problems,
                            message: describeContentProblems(problems)
                        });
                    }
                }
            },
    
            getPlainText(html) {
                return stripHtml(html);   // #1952 — shared, was duplicated in ten files
            },
    
            // #1952 — one shared rule set (src/contentRules.js). This used to carry
            // four patterns inline, duplicated verbatim across ten components; two of
            // them rejected indentation, tabs, ---- dividers and ellipses.
            containsInvalidContent(text) {
                return findContentProblems(text).length > 0;
            },

            hasValidationErrors() {
                // Check if any field has errors
                if (!this.error) return false;
                
                return Object.values(this.error).some(error => error.hasError === true);
            },
        },
        created() {
            this.checkSteward();
            if(this.$cookies.get('csLogin')=='client-admin'){
               this.getEmployees(); 
           }else{
                this.type = 'job'
                this.getJob();
           }
           this.getClientData();    
        }
    }

</script>
<style scoped>
.err-msg {
    margin: 2px;
    color: red
}
.n-sms-margin{
    margin-bottom: 35px;
}
.ml-45 {
    margin-left: 45px;
}

.ml-15 {
    margin-left: 15px;
}
.mb-10 {
    margin-bottom: 10px;
}
</style>
